import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateOrder',
    standalone: false
})
export class TranslateOrderPipe implements PipeTransform {
    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private translate: TranslateService) {}

    transform(keys: any[]): any[] {
        if (!Array.isArray(keys)) {
            return keys;
        }

        return keys.sort((a, b) => {
            if (this.translate.instant(a.translationKey) < this.translate.instant(b.translationKey)) {
                return -1;
            }
            if (this.translate.instant(a.translationKey) > this.translate.instant(b.translationKey)) {
                return 1;
            }
            return 0;
        });
    }
}
